import { useState } from 'react';
import Slider from 'components/hands/jsx/Slider';
import { Controller } from 'components/hands/jsx/Controller';
import { HandTable } from 'components/hands/jsx/HandTable';
import 'components/hands/css/Hands.css';
import { usePokerGame } from 'components/hands/context/PokerGameContext';
import PaypalButton from 'components/paypal/PaypalButton';

const Hands = () => {
  const { gameState, saveHand } = usePokerGame();
  const [saveStatus, setSaveStatus] = useState(null);

  const handleSave = async () => {
    setSaveStatus('saving');
    try {
      const id = await saveHand();
      setSaveStatus(`saved:${id}`);
    } catch (err) {
      console.error('Save hand failed', err);
      setSaveStatus(`error:${err.message}`);
    }
  };

  return (
    <div className="hands-container">
      <div className="hands-main-card">
        <h1 className="hands-title">Poker Hand Tracker</h1>

        <div className="hands-slider-section">
          <Slider
            currentSliderValue={gameState.tableSize}
            setCurrentSliderValue={(v) => console.log('TODO: update table size', v)}
          />
        </div>

        <div className="hands-controller-section">
          <Controller />
        </div>

        <div className="hands-toggle-section">
          <button
            onClick={handleSave}
            className="btn-view-table"
            disabled={saveStatus === 'saving'}
          >
            {saveStatus === 'saving' ? 'Saving...' : 'Save Hand'}
          </button>
          {saveStatus?.startsWith('saved:') && (
            <span className="text-success" style={{ marginLeft: 8 }}>
              Saved ({saveStatus.split(':')[1]})
            </span>
          )}
          {saveStatus?.startsWith('error:') && (
            <span className="text-danger" style={{ marginLeft: 8 }}>
              {saveStatus.split(':')[1]}
            </span>
          )}
        </div>

        <HandTable gameState={gameState} />

        <div className="hands-paypal-section">
          <PaypalButton />
        </div>
      </div>
    </div>
  );
};

export default Hands;
